export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-chord/src/constant.js
// module id = G5Bq
// module chunks = 0